import { createStyles, withStyles } from '@material-ui/core';
import { useTheme, makeStyles } from '@material-ui/styles';
export default withStyles;
export { createStyles, useTheme, makeStyles };
//# sourceMappingURL=withStyles.js.map